/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_Create_TitleInputs */

const cs_parties_create_title = /** @type {(inputs: Parties_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová strana`)
};

const en_parties_create_title = /** @type {(inputs: Parties_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New party`)
};

/**
* | output |
* | --- |
* | "New party" |
*
* @param {Parties_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_create_title = /** @type {((inputs?: Parties_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_create_title(inputs)
	return cs_parties_create_title(inputs)
});